import axios from 'axios'
import {
  message as antMessage
} from 'ant-design-vue'
import cookieUtil from './cookie-util'
import { parseJsonPreserveLongIds } from './json-util'
import { blobDownloads } from './tools'

import router from '../router/index'

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 15000
})
axiosInstance.interceptors.request.use(config => {
  config.headers.Authorization = cookieUtil.getToken()
  return config
}, error => {
  console.log(error)
  return Promise.reject(error)
})

const pipe = res => {
  return new Promise((resolve, reject) => res
    .then(data => {
      const {
        status,
        message
      } = data.data
      if (status === 200) resolve(data.data)
      else if (status === 400) {
        cookieUtil.removeToken()
        antMessage.error(message)
        router.push({
          path: '/'
        })
        reject(data.data)
      } else {
        antMessage.error(message || '请求失败')
        reject(data.data)
      }
    }).catch(e => {
      let errorMessage = '请求失败'
      const errorString = e && e.toString ? e.toString() : ''
      if (errorString.includes('timeout of')) {
        errorMessage = '请求超时'
      } else if (errorString.includes('Network Error')) {
        errorMessage = '服务器未响应,请检查网络'
      }
      antMessage.error(errorMessage)
      reject(e)
    })
  )
}

const post = (url, data) => {
  return pipe(axiosInstance({
    url: url,
    method: 'post',
    data: data
  }))
}

/** POST，Content-Type: application/x-www-form-urlencoded（对应 Apifox 表单提交） */
const postForm = (url, params = {}) => {
  const body = new URLSearchParams()
  Object.entries(params).forEach(([key, val]) => {
    if (val !== undefined && val !== null) {
      body.append(key, String(val))
    }
  })
  return pipe(
    axiosInstance({
      url,
      method: 'post',
      data: body.toString(),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
  )
}

const get = (url, params) => {
  return pipe(axiosInstance({
    url: url,
    method: 'get',
    params: params
  }))
}

/**
 * GET 请求并保留大整数 id（用于详情回显等接口）
 * 与 get 相同，但在 JSON.parse 前将雪花 id 转为字符串
 */
const getPreserveLongId = (url, params, longIdFields) => {
  return new Promise((resolve, reject) => {
    axiosInstance({
      url,
      method: 'get',
      params,
      transformResponse: [(data) => data]
    })
      .then((response) => {
        try {
          const parsed = parseJsonPreserveLongIds(response.data, longIdFields)
          const { status, message } = parsed
          if (status === 200) resolve(parsed)
          else if (status === 400) {
            cookieUtil.removeToken()
            antMessage.error(message)
            router.push({ path: '/' })
            reject(parsed)
          } else {
            antMessage.error(message || '请求失败')
            reject(parsed)
          }
        } catch (e) {
          antMessage.error('请求失败')
          reject(e)
        }
      })
      .catch((e) => {
        let errorMessage = '请求失败'
        const errorString = e && e.toString ? e.toString() : ''
        if (errorString.includes('timeout of')) {
          errorMessage = '请求超时'
        } else if (errorString.includes('Network Error')) {
          errorMessage = '服务器未响应,请检查网络'
        }
        antMessage.error(errorMessage)
        reject(e)
      })
  })
}

const deletes = (url, params) => {
  return pipe(axiosInstance({
    url: url,
    method: 'delete',
    params: params
  }))
}

const downFile = (url, args = {}, method = 'get') => {
  const requestParams = {
    url: url,
    method: method,
    responseType: 'blob'
  }
  const paramsKey = method === 'get' ? 'params' : 'data'
  requestParams[paramsKey] = args.params
  return axiosInstance(requestParams).then((res) => {
    blobDownloads(res, args.fileName)
    return res
  })
}

export {
  axiosInstance,
  axios,
  post,
  postForm,
  get,
  getPreserveLongId,
  deletes,
  downFile
}
